export const SET_ITENS = 'setUser';
export const LOADING = 'setLoading';
